import { type IArrowLocation } from '@repo/sdk'
import { ArrowRightIcon, Circle, Square } from 'lucide-react'

interface IProps {
  data: IArrowLocation
}

export const ArrowLocation = ({ data }: IProps) => {
  return (
    <div
      className={
        'flex w-full items-center justify-start overflow-hidden text-center text-sm font-bold'
      }
    >
      <Square className={'grab mt-0.5'} fill={'black'} size={10} />
      <div className={'ml-2 max-h-5 max-w-full overflow-hidden text-ellipsis whitespace-nowrap'}>
        {`${data.origin.city}, ${data.origin.country_code}`}
      </div>

      <ArrowRightIcon
        style={{
          height: '24px',
          marginLeft: '4px',
          marginRight: '4px',
          marginTop: '0',
          minWidth: '24px',
          width: '24px',
        }}
      />

      <Circle className={'grab mt-0.5'} fill={'black'} size={10} />
      <div className={'ml-2 max-h-5 max-w-full overflow-hidden text-ellipsis whitespace-nowrap'}>
        {`${data.destination.city}, ${data.destination.country_code}`}
      </div>
    </div>
  )
}
